import { AssessmentStatus as Assessment_Status_Enum } from '@risksmart-app/domain/src/types/consts/assessment-status';
import type { InsertAssessmentMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import {
  InsertAssessmentDocument,
  namedOperations,
} from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

import type { InsertAssessmentInput, InsertAssessmentRequest } from './types';

export const useInsertAssessment = createMutationHook({
  name: 'insertAssessment',
  isIdempotentCreate: true,
  mutationOptions: (trpc, onSuccess, requestContext) =>
    trpc.frontend.assessment.insert.mutationOptions({
      onSuccess,
      trpc: { context: requestContext },
    }),
  mapInput: (variables: InsertAssessmentInput): InsertAssessmentRequest => ({
    ...variables,
    Title: variables.Title ?? '',
    Status: variables.Status ?? Assessment_Status_Enum.NotStarted,
  }),
  invalidate: (trpc) => [
    // COI-889: router-level key — the hand-listed set missed `assessmentCount`,
    // the left-nav badge.
    trpc.frontend.assessment.pathKey(),
    // COI-889: the my-items ribbon counts this entity.
    trpc.frontend.myItems.pathKey(),
  ],
  mapResponse: (result: { Id: string }): InsertAssessmentMutation => ({
    insertAssessmentApi: {
      __typename: 'IdOutput',
      Id: result.Id,
    },
  }),
  graphqlDocument: InsertAssessmentDocument,
  graphqlVariables: (variables: InsertAssessmentInput) => ({
    object: variables,
  }),
  evictFields: ['assessment', 'assessment_aggregate'],
  refetchQueries: [
    namedOperations.Query.getAssessmentById,
    namedOperations.Query.getAssessments,
  ],
});
